import { createContext, useContext } from 'react';

// Minimal interface for flags that works with both Atlaskit and Confluence flags
// Confluence's showFlag returns Promise<FlagDescriptor>, Atlaskit's returns DismissFn
export type FlagsContainer = {
	showFlag: (flag: Record<string, unknown>) => unknown;
};

type FlagsProviderContextValue = {
	flags: FlagsContainer | undefined;
};

export const FlagsProviderContext = createContext<FlagsProviderContextValue>({
	flags: undefined,
});

FlagsProviderContext.displayName = 'FlagsProviderContext';

export const useFlags = (): FlagsContainer | undefined => {
	const context = useContext(FlagsProviderContext);
	return context.flags;
};
